export enum MyQuotesDialogModeEnum {
    BOTH,
    HARDWARE_ONLY,
    SUPPLY_ONLY ,
}
